<template>
  <div class="dialog">
    <div class="container" :class="{ hidden: !show }">
      <div
        style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
        v-html="$t('homePageTexts.animationGen_quit')"
      ></div>
      <img
        :src="getPic('no')"
        class="no btn hoverable-button"
        handler-id="no"
        @mouseover="handleHoverEvent('no')"
        @mouseout="handleUnhoverEvent('no')"
        @click="handleActivateEventInComponent('no')"
        alt=""
      />
      <img
        :src="getPic('yes')"
        class="yes btn hoverable-button"
        handler-id="yes"
        @mouseover="handleHoverEvent('yes')"
        @mouseout="handleUnhoverEvent('yes')"
        @click="handleActivateEventInComponent('yes')"
        alt=""
      />
      <img
        @load="picLoaded"
        v-if="show"
        class="corner-ninja"
        :src="getCurrentGif()"
        alt=""
      />
      <!-- <img
        v-if="show"
        class="corner-ninja"
        src="../../assets/img/ninja_corner/corner_talk.gif"
        alt=""
      /> -->
    </div>
    <audio ref="confirm">
      <source src="../../assets/sound/confirm_exit.ogg" type="audio/ogg" />
    </audio>
    <audio ref="back" @ended="voiceEnded">
      <source src="../../assets/sound/back_sure.mp3" type="audio/mpeg" />
    </audio>
  </div>
</template>

<script>
import appConstants from '@/config/constants';
import appConfig from '@/config/config';
import handHoverMixin from '@/mixins/hand-hover-mixin.js';

export default {
  name: 'Dialog',
  mixins: [handHoverMixin],
  data() {
    return {
      show: false,
      resolve: null,
      reject: null,
      btnClasses: {
        yes: '',
        no: ''
      },
      currentGif: 'up'
    };
  },
  watch: {
    show() {
      this.currentGif = appConstants.gifs.up;
    }
  },
  methods: {
    voiceEnded() {
      this.currentGif = appConstants.gifs.static;
    },
    picLoaded() {
      if (this.currentGif === appConstants.gifs.up) {
        setTimeout(() => {
          // TODO: add sound here
          // if this audio was paused earlier, playing it will play the audio from the same "time" it was paused at.
          // since html has no stop function, the audio must be reloaded.
          this.$refs.back.load();
          this.$refs.back.play();
          this.currentGif = appConstants.gifs.talk;
        }, 700);
        // setTimeout(() => {
        //   this.currentGif = appConstants.gifs.up;
        // }, 1000);
      }
    },
    getCurrentGif() {
      const imgs = {
        up: require('../../assets/img/ninja_corner/corner_up.gif'),
        talk: require('../../assets/img/ninja_corner/corner_talk.gif'),
        static: require('../../assets/img/ninja_corner/ninja_corner.png'),
        out: require('../../assets/img/ninja_corner/corner_down.gif')
      };
      return imgs[this.currentGif];
    },
    costumConfirm() {
      // this function opens the dialog!
      // console.log('dialog');
      setTimeout(() => {
        this.show = true;
      }, appConfig.soundDelay);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    handleActivateEventInComponent(handlerId) {
      this.next(handlerId === appConstants.yes);
    },
    next(didUserAgree /* Boolean*/) {
      if (this.resolve) {
        this.currentGif = appConstants.gifs.out;
        this.$refs.confirm.play();
        setTimeout(() => {
          this.$refs.back.pause();
          this.resolve(didUserAgree);
          this.show = false;
        }, appConfig.gifDelay);
      }
    },
    // agree() {
    //   if (this.resolve) {
    //     this.currentGif = appConstants.gifs.out;
    //     this.$refs.confirm.play();
    //     setTimeout(() => {
    //       this.$refs.confirm.pause();
    //       this.resolve(true);
    //       this.show = false;
    //     }, appConfig.gifDelay);
    //   }
    // },
    // decline() {
    //   if (this.resolve) {
    //     this.currentGif = appConstants.gifs.out;
    //     this.$refs.confirm.play();
    //     setTimeout(() => {
    //       this.$refs.confirm.pause();
    //       this.resolve(false);
    //       this.show = false;
    //     }, appConfig.gifDelay);
    //   }
    // },
    getImgNameExta(handlerId) {
      if (
        this.btnClasses[handlerId] === appConstants.hover ||
        this.btnClasses[handlerId] === appConstants.activate
      ) {
        return '_' + appConstants.hover;
      }
      return '';
    },
    getPic(handlerId) {
      try {
        return require(`@/assets/img/btns/${handlerId}${this.getImgNameExta(
          handlerId
        )}.png`);
      } catch (err) {
        console.warn({ err });
        return require('@/assets/img/btns/no.png');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog {
  z-index: -1;
  cursor: inherit;
}

.hidden {
  opacity: 0;
  cursor: inherit;
}

.container {
  z-index: -1;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.25);
}

.yes,
.no {
  opacity: 1;
  transition: opacity 0.3s;
  position: absolute;
  width: 20%;
  top: 0;
}

.yes {
  left: 24%;
}

.no {
  right: 24%;
}

.corner-ninja {
  position: absolute;
  z-index: -1;
}
</style>
